import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        await loginWithGoogle(sessionId);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Google auth failed:", err);
        navigate("/login");
      }
    })();
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#0A0A0C' }}>
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#E31937] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Completing sign in...</p>
      </div>
    </div>
  );
}
